export const getUserMarketsState = state => state.userMarkets;
